import { render } from "./shift.vue?vue&type=template&id=4fcc906c"
import script from "./shift.vue?vue&type=script&lang=js"
export * from "./shift.vue?vue&type=script&lang=js"

import "./shift.vue?vue&type=style&index=0&id=4fcc906c&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__